import { Base64 } from "base64-string";
import { IDecryptedKeys } from "./decryptKeys";
import { decryptMasterKey } from "./decryptMasterKey";
import { decryptIntermidatePrivateKey } from "./decryptIntermidatePrivateKey";
// import { decryptIntermidatePublicKey } from './decryptIntermidatePublicKey';
import * as openpgp from "openpgp";
import { readFileFromBase64 } from "./readFileFromBase64";
import { IStoredKeys } from "dto/ContactForm/IStoredKeys";
import CryptoJS from "crypto-js";

export const getKeys = async (
  userId: string,
  chatId?: string,
): Promise<IDecryptedKeys | null> => {
  console.log("Getting userKeys", userId, chatId);

  if (!chatId) {
    const serializedKeys = localStorage.getItem(`${userId}.keys`);
    if (!serializedKeys?.length) return null;

    const enc = new Base64();
    const keys = JSON.parse(enc.decode(serializedKeys));

    keys.masterKey = await decryptMasterKey(keys);
    keys.intermidatePrivateKey = await decryptIntermidatePrivateKey(keys);
    //
    // keys.IntermediatePublicKey = await decryptIntermidatePublicKey(keys);

    return keys;
  } else {
    const SECRET_KEY = import.meta.env.VITE_APP_SECRET_KEY; // from .env
    const keyPack = localStorage.getItem(chatId);
    if (!keyPack?.length) return null;

    console.log("Decoding chat keypack");

    try {
      const bytes = CryptoJS.AES.decrypt(keyPack, SECRET_KEY);
      const keyJson = JSON.parse(
        bytes.toString(CryptoJS.enc.Utf8),
      ) as IStoredKeys;

      const keyBuffer = await readFileFromBase64(
        keyJson.Private,
        "application/other",
      );
      const notArmoredKey = await openpgp.key.read(new Uint8Array(keyBuffer));

      const k = notArmoredKey.keys[0].armor();

      return {
        publicKeyArmored: undefined,
        privateBase64Key: undefined,
        privateKeyArmored: undefined,
        recoveryPackage: undefined,
        privateKey: undefined,
        publicBase64Key: undefined,
        publicKey: undefined,
        intermidatePrivateKey: {
          data: btoa(k),
          filename: "",
          signatures: undefined,
        },
      };
    } catch (error) {
      console.error(error);
    }

    return null;
  }
};
